export { default as AvatarMenuDumbV2 } from './avatar-menu-dumb-v2';
